import { AccessChangesTable } from './access-changes-table';
import { AccessStatistics } from './access-statistics/AccessStatistics';
import { ApiVolumeGraph } from './api-volume/ApiVolumeGraph';
import { AppStatusTable } from './application-status';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityViewContainer } from './DataSecurityViewContainer';
import { DetectedApplications } from './detected-applications';
import { IncidentLogTable } from './incident-log-table';
import React from 'react';
import { SystemOverview } from './system-overview';
import { UptimeMonitorsDashboard } from './uptime-monitors-dashboard';
import { VerticalColumn } from '@ui/general/VerticalColumn';
export const DataSecurityDashboard = ({ viewParams, onViewChange }) => React.createElement(DataSecurityViewContainer, { onViewChange: onViewChange, title: COPY_SPECIFIC.DASHBOARD, viewParams: viewParams },
    React.createElement(VerticalColumn, null,
        React.createElement(UptimeMonitorsDashboard, null),
        React.createElement(SystemOverview, null),
        React.createElement(DetectedApplications, null)),
    React.createElement(VerticalColumn, null,
        React.createElement(ApiVolumeGraph, { showExploreButton: true, viewParams: viewParams }),
        React.createElement(AccessStatistics, { viewParams: viewParams }),
        React.createElement(AccessChangesTable, { viewParams: viewParams }),
        React.createElement("div", { className: 'column-row' },
            React.createElement(AppStatusTable, null),
            React.createElement(IncidentLogTable, { viewParams: viewParams }))));
